import Axios, { AxiosRequestConfig } from 'axios';

import { API_URL_MAIN } from '@/config';
import { HttpStatus, HttpStatusError } from '@/types';
import { refreshToken } from '@/utils/common';
import storage from '@/utils/storage';

const authRequestInterceptor = (config: AxiosRequestConfig) => {
  const token = storage.getToken()?.access_token;
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  config.headers.Accept = 'application/json';
  return config;
};

export const axios = Axios.create({
  baseURL: API_URL_MAIN,
});

axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config;
    //get new access token and retry
    if (status === HttpStatus.UNAUTHORIZED && !originalRequest._retry) {
      originalRequest._retry = true;
      await refreshToken();
      const token = storage.getToken()?.access_token;
      axios.defaults.headers.authorization = `Bearer ${token}`;
      return axios(originalRequest);
    }

    let message = error.response?.data?.message || error.message;

    // Use the HttpStatus enum to handle different status codes
    switch (status) {
      case HttpStatus.BAD_REQUEST:
        message = HttpStatusError.BAD_REQUEST;
        break;
      case HttpStatus.METHOD_NOT_ALLOWED:
        message = HttpStatusError.METHOD_NOT_ALLOWED;
        break;
      case HttpStatus.INTERNAL_SERVER_ERROR:
        message = HttpStatusError.INTERNAL_SERVER_ERROR;
        break;
      case HttpStatus.SERVICE_UNAVAILABLE:
        message = HttpStatusError.SERVICE_UNAVAILABLE;
        break;
      case HttpStatus.REQUEST_TIMEOUT:
        message = HttpStatusError.REQUEST_TIMEOUT;
        break;

      // Add more cases for other status codes as needed
      default:
        message = '';
    }
    return Promise.reject(error);
  }
);
